import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "museum-loader",
    templateUrl: "./museum-loader.component.html",
    styleUrls: ["./museum-loader.component.scss"],
})
export class MuseumLoaderComponent implements OnInit {
    @Input() whitify = false;

    constructor() {}

    ngOnInit(): void {
        if (this.whitify) {
            const mainDiv = document.getElementById("loader-main-div");
            if (mainDiv) {
                mainDiv.classList.add("whitify");
            }
        }
    }
}
